import * as React from "react";

const Sainsburys = (props) =>
  /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement(
      "defs",
      null,
      /*#__PURE__*/ React.createElement(
        "clipPath",
        {
          id: "b",
        },
        /*#__PURE__*/ React.createElement("path", {
          d:
            "M29.27 5.38h-2.62a.31.31 0 0 0-.27.32v11.56a.31.31 0 0 0 .28.33h2.61a.32.32 0 0 0 .33-.33V5.71a.31.31 0 0 0-.32-.33m49.94-.13H76.6a.31.31 0 0 0-.28.33v7.93c0 1.77-.53 2.72-2.23 2.73a2 2 0 0 1-2.21-2.07V5.59a.31.31 0 0 0-.32-.33h-2.62a.3.3 0 0 0-.27.32v8c0 3.05 2.74 4.19 5.44 4.18s5.44-1.15 5.43-4.53V5.57a.31.31 0 0 0-.33-.32m22.8 0h-1.24a.39.39 0 0 0-.39.3l-2.68 7.31-.16.52-.17-.52-2.79-7.35a.4.4 0 0 0-.43-.3h-3c-.16 0-.24.08-.24.25a1.31 1.31 0 0 0 .14.43l5 11.46c0 2-2 2.71-4.11 2.11a3.43 3.43 0 0 0-.84-.16.39.39 0 0 0-.36.38v1.55a.62.62 0 0 0 .55.57 3.53 3.53 0 0 0 1.14.14 5.32 5.32 0 0 0 4.74-3.25l5-12.91a1.05 1.05 0 0 0 .11-.35.24.24 0 0 0-.28-.23M44.89 9c0 4.34 6.87 3.42 6.87 5.77 0 1.87-3.23 2.08-5.58.29a.79.79 0 0 0-.52-.23c-.27 0-.44.12-.43.5v1.06a.68.68 0 0 0 .41.7c3 1.36 8.58 1.38 8.57-3.63 0-4.31-7-3.32-7-5.47 0-1.77 3.4-1.61 5.36-.28a1.16 1.16 0 0 0 .52.21c.28 0 .44-.1.43-.49v-.9a.67.67 0 0 0-.4-.7 9.18 9.18 0 0 0-3.44-.69c-2.57 0-4.85 1.2-4.84 3.86m-28.17 5.17c0-1.47 1.14-2.84 4.16-2.85v3.61a2.31 2.31 0 0 1-2.18 1.3 1.88 1.88 0 0 1-2-2.06M19 5.07a10.29 10.29 0 0 0-4.25.85.71.71 0 0 0-.4.66V7.8a.52.52 0 0 0 .46.55c.33 0 .57-.31.73-.42a5.74 5.74 0 0 1 3.35-1.15c1.67 0 1.92 1.09 1.92 2.42 0 .63-.22.79-2.59 1.1-1.45.2-4.74.85-4.73 3.82 0 2.46 2 3.76 4.26 3.76a4.79 4.79 0 0 0 3.15-1.32l.07.71a.3.3 0 0 0 .27.32h2.48a.32.32 0 0 0 .32-.33V8.79c0-2.2-1.17-3.72-5-3.72M39.39 5a8.47 8.47 0 0 0-3.91 1.24l-.06-.62a.32.32 0 0 0-.32-.34h-2.55a.31.31 0 0 0-.27.33V17.2a.32.32 0 0 0 .28.34h2.64a.31.31 0 0 0 .33-.33V7.86A5.68 5.68 0 0 1 38.05 7C39.86 7 40 8.13 40 9.06v8.18a.31.31 0 0 0 .27.33h2.63a.31.31 0 0 0 .33-.33V8.79C43.19 6.57 42 5.05 39.4 5m48.93 0a4.39 4.39 0 0 0-3.26 2V5.53a.32.32 0 0 0-.33-.33h-2.59a.31.31 0 0 0-.27.33v11.55a.31.31 0 0 0 .27.33h2.65a.32.32 0 0 0 .32-.33V9.76c0-2.35 2.22-2.44 3.7-2.14a4.44 4.44 0 0 0 .92.19.38.38 0 0 0 .36-.38V5.71a.6.6 0 0 0-.54-.57A4.24 4.24 0 0 0 88.35 5m16.84 3.85c0 4.33 6.87 3.41 6.88 5.76 0 1.88-3.25 2.08-5.59.29a.72.72 0 0 0-.52-.22c-.27 0-.43.11-.43.49v1.06a.7.7 0 0 0 .4.71c3 1.35 8.59 1.37 8.58-3.64 0-4.31-7-3.31-7-5.47 0-1.77 3.4-1.61 5.36-.28a1.19 1.19 0 0 0 .52.22c.28 0 .44-.11.44-.5v-.88a.66.66 0 0 0-.42-.71A9.05 9.05 0 0 0 110 5c-2.57 0-4.84 1.21-4.84 3.87m-99-8C2.53.9.57 3.14.58 5.67c0 5.51 8.5 4.35 8.51 8.08C9.1 16 5.83 17.6 2 15c-.36-.24-.52-.38-.76-.38-.46 0-.55.25-.55.5v1.38a.54.54 0 0 0 .32.55c4.58 2.14 11.1.87 11.08-4.6 0-5-8.64-4.7-8.65-7.8 0-1.26 1.2-2.1 2.72-2.11A5.64 5.64 0 0 1 9.7 3.75a1.34 1.34 0 0 0 .74.35c.29 0 .38-.19.38-.44V2.08a.44.44 0 0 0-.3-.49 13.08 13.08 0 0 0-4.34-.7m53.11 15.18a.76.76 0 0 1-.38-.71V8A3.51 3.51 0 0 1 61 7.15c2.47 0 2.73 3.21 2.74 4.35 0 3.06-1.23 4.86-3 4.86a2.85 2.85 0 0 1-1.46-.29M58.54.78h-2.61a.3.3 0 0 0-.27.32v14.07a1.49 1.49 0 0 0 .5 1.25 7 7 0 0 0 4.36 1.4c3.59 0 6.5-2.79 6.5-7 0-3.26-1.79-5.71-4.59-5.71a5.42 5.42 0 0 0-3.57 1.4V1.09a.31.31 0 0 0-.32-.33M27.93.72c-1.2 0-1.77.72-1.77 1.54a1.62 1.62 0 0 0 1.78 1.63 1.56 1.56 0 0 0 1.71-1.64A1.53 1.53 0 0 0 27.93.72m76.93 0h-1.29c-.3 0-.35.22-.35.38 0 .34.82 1.16.83 2.28a6.64 6.64 0 0 1-.44 1.92c0 .14.14.24.33.24h.57c1.29 0 2.73-4.82.36-4.82",
          style: {
            fill: "none",
          },
        })
      )
    ),
    /*#__PURE__*/ React.createElement("path", {
      d:
        "M26.3 5.71v11.56a.31.31 0 0 0 .27.33h2.62a.31.31 0 0 0 .32-.33V5.72a.32.32 0 0 0-.33-.33h-2.6a.31.31 0 0 0-.28.32M3.41 4.61c0-1.26 1.2-2.1 2.72-2.11a5.64 5.64 0 0 1 3.49 1.25 1.37 1.37 0 0 0 .74.35c.3 0 .38-.19.38-.44V2.08a.45.45 0 0 0-.29-.49 13.39 13.39 0 0 0-4.37-.7C2.45.9.49 3.14.5 5.67.51 11.18 9 10 9 13.75 9 16 5.76 17.6 2 15c-.35-.24-.51-.38-.76-.38-.46 0-.54.25-.54.5v1.38a.54.54 0 0 0 .3.5c4.59 2.14 11.1.87 11.09-4.6 0-5-8.65-4.7-8.66-7.8m17.34 10.33a2.33 2.33 0 0 1-2.19 1.3 1.88 1.88 0 0 1-2-2.06c0-1.47 1.14-2.84 4.17-2.85ZM24 17.26V8.79c0-2.21-1.18-3.73-5-3.72a10.25 10.25 0 0 0-4.24.85.72.72 0 0 0-.41.66V7.8a.52.52 0 0 0 .46.55c.33 0 .57-.31.74-.42a5.71 5.71 0 0 1 3.35-1.15c1.66 0 1.91 1.09 1.91 2.42 0 .63-.21.79-2.58 1.1-1.45.2-4.75.85-4.74 3.82 0 2.46 2 3.76 4.26 3.76a4.82 4.82 0 0 0 3.16-1.32l.06.71a.3.3 0 0 0 .27.32h2.48a.32.32 0 0 0 .33-.33m5.58-15A1.54 1.54 0 0 0 27.85.72a1.56 1.56 0 0 0-1.76 1.54 1.61 1.61 0 0 0 1.77 1.63 1.58 1.58 0 0 0 1.72-1.64m13.57 15V8.8c0-2.21-1.18-3.74-3.81-3.73a8.32 8.32 0 0 0-3.9 1.23l-.06-.62a.32.32 0 0 0-.38-.36h-2.52a.31.31 0 0 0-.28.33v11.59a.31.31 0 0 0 .27.34h2.62a.32.32 0 0 0 .34-.33V7.9A5.68 5.68 0 0 1 38 7c1.81 0 1.93 1.09 1.93 2v8.18a.31.31 0 0 0 .27.33h2.62a.31.31 0 0 0 .33-.33m4-9.26c0-1.77 3.4-1.61 5.37-.28a1.12 1.12 0 0 0 .52.21c.27 0 .43-.1.43-.49v-.9a.67.67 0 0 0-.41-.7c-3.52-1.42-8.25-.61-8.25 3.24 0 4.34 6.87 3.42 6.88 5.77 0 1.87-3.24 2.08-5.59.29a.79.79 0 0 0-.51-.23c-.27 0-.44.12-.44.5v1.06a.68.68 0 0 0 .42.7c3 1.36 8.58 1.38 8.57-3.63 0-4.31-7-3.32-7-5.47m16.51 3.51c0 3.06-1.22 4.86-3 4.86a2.79 2.79 0 0 1-1.47-.29.76.76 0 0 1-.38-.71V8a3.57 3.57 0 0 1 2.1-.85c2.48 0 2.74 3.21 2.74 4.35m3.36-.66c0-3.26-1.78-5.71-4.59-5.71a5.44 5.44 0 0 0-3.57 1.4V1.11a.32.32 0 0 0-.33-.33h-2.65a.3.3 0 0 0-.27.32v14.07a1.48 1.48 0 0 0 .49 1.25 7 7 0 0 0 4.36 1.4c3.6 0 6.51-2.79 6.5-7m12.54 2.38V5.57a.3.3 0 0 0-.32-.32h-2.64a.31.31 0 0 0-.27.33v7.93c0 1.77-.54 2.72-2.23 2.73a2 2 0 0 1-2.22-2.07V5.59a.31.31 0 0 0-.32-.33h-2.62a.3.3 0 0 0-.27.33v8c0 3.05 2.73 4.19 5.43 4.18s5.44-1.15 5.44-4.53M90 7.43V5.71c0-.27-.19-.49-.55-.57A3.94 3.94 0 0 0 85 7l-.06-1.47a.32.32 0 0 0-.32-.33h-2.54a.3.3 0 0 0-.27.33v11.55a.31.31 0 0 0 .27.33h2.62a.32.32 0 0 0 .33-.33V9.73c0-2.35 2.22-2.44 3.7-2.14a4.44 4.44 0 0 0 .92.19.38.38 0 0 0 .35-.35m12.07-1.64a1.36 1.36 0 0 0 .11-.35.25.25 0 0 0-.25-.24h-1.25a.39.39 0 0 0-.39.3l-2.68 7.36-.16.52-.16-.52-2.78-7.35a.41.41 0 0 0-.44-.3h-3c-.16 0-.24.08-.24.25a1.31 1.31 0 0 0 .17.44l5 11.46c0 2-2 2.71-4.11 2.11a3.27 3.27 0 0 0-.84-.16.39.39 0 0 0-.36.38v1.55a.6.6 0 0 0 .54.57 3.27 3.27 0 0 0 1.15.13 5.28 5.28 0 0 0 4.73-3.24Zm2.72-5.11h-1.3c-.29 0-.35.22-.35.39 0 .33.83 1.14.83 2.27a6.64 6.64 0 0 1-.44 1.92c0 .14.14.25.34.24h.57c1.29 0 2.73-4.83.35-4.82m9 6.6v-.89a.67.67 0 0 0-.41-.71c-3.54-1.47-8.28-.66-8.28 3.18 0 4.33 6.87 3.41 6.88 5.76 0 1.88-3.24 2.08-5.58.29a.79.79 0 0 0-.52-.23c-.27 0-.43.12-.43.5v1.06a.7.7 0 0 0 .41.71c3 1.35 8.58 1.37 8.57-3.64 0-4.31-7-3.31-7-5.47 0-1.77 3.4-1.61 5.37-.28a1.15 1.15 0 0 0 .52.22c.27 0 .44-.11.44-.5",
      style: {
        fill: "#1d1d1b",
      },
    }),
    /*#__PURE__*/ React.createElement(
      "g",
      {
        style: {
          clipPath: "url(#b)",
        },
      },
      /*#__PURE__*/ React.createElement("path", {
        transform: "rotate(-45.5 70.53 24.823)",
        style: {
          fill: "#008035",
        },
        d: "M63.25-101.93h14.56V151.6H63.25z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        transform: "rotate(-45.5 80.652 14.528)",
        style: {
          fill: "#f59f00",
        },
        d: "M73.38-112.24h14.56v253.53H73.38z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        transform: "rotate(-45.5 90.79 4.226)",
        style: {
          fill: "#e20613",
        },
        d: "M83.5-122.54h14.56v253.53H83.5z",
      })
    )
  );

Sainsburys.defaultProps = {
  viewBox: "0 0 115 23",
  role: "img",
};

const Nectar = (props) =>
  /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement(
      "defs",
      null,
      /*#__PURE__*/ React.createElement(
        "clipPath",
        {
          id: "a",
        },
        /*#__PURE__*/ React.createElement("path", {
          d:
            "M23.83 0C9 0 .46 10.12.48 18.08.5 26.63 9 28.3 13 28.29c6.1 0 8.32-.56 12.84 1.4C34.1 33.31 34.29 40 37.79 40c2.29 0 9.75-10 9.73-18.87C47.5 9.61 36.83 0 23.88 0h-.05",
          style: {
            fill: "none",
          },
        })
      )
    ),
    /*#__PURE__*/ React.createElement("path", {
      d:
        "M.48 18.08C.46 10.12 9 0 23.83 0c13 0 23.66 9.59 23.69 21.13C47.54 30 40.08 40 37.79 40c-3.5 0-3.69-6.69-12-10.31-4.52-2-6.74-1.41-12.84-1.4C9 28.3.5 26.63.48 18.08",
      style: {
        fill: "#1d1d1b",
      },
    }),
    /*#__PURE__*/ React.createElement(
      "g",
      {
        style: {
          clipPath: "url(#a)",
        },
      },
      /*#__PURE__*/ React.createElement("path", {
        transform: "rotate(-45.5 30.785 15.222)",
        style: {
          fill: "#008035",
        },
        d: "M28.57-23.27h4.42v77h-4.42z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        transform: "rotate(-45.5 33.862 12.096)",
        style: {
          fill: "#f59f00",
        },
        d: "M31.65-26.4h4.42v77h-4.42z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        transform: "rotate(-45.5 36.94 8.97)",
        style: {
          fill: "#e20613",
        },
        d: "M34.72-29.53h4.42v77h-4.42z",
      })
    ),
    /*#__PURE__*/ React.createElement("path", {
      d:
        "M33.93 19.24a1.81 1.81 0 0 1-1.79-1.78 1.79 1.79 0 1 1 1.79 1.78m4 .86a9.74 9.74 0 0 1-.49-1.43 8.7 8.7 0 0 1-.21-2.28v-1.74a.33.33 0 0 0-.33-.32h-1a.32.32 0 0 0-.32.33 2.84 2.84 0 0 0-1.7-.49 3.25 3.25 0 1 0 0 6.5 2.82 2.82 0 0 0 2-.69c.11-.09.19-.08.27 0 .29.34.29.53.72.52h.72a.31.31 0 0 0 .29-.45M12.29 17a2.46 2.46 0 0 0-2.52-2.77 3.4 3.4 0 0 0-1.74.3s-.69-.17-1.15-.23a.32.32 0 0 0-.36.32v5.68a.33.33 0 0 0 .32.32h1a.33.33 0 0 0 .32-.33v-3.08c0-1.19.64-1.44 1.28-1.44s1.28.26 1.28 1.46v3.06a.32.32 0 0 0 .32.32h1a.32.32 0 0 0 .32-.33Zm29.92-2.84a7 7 0 0 0-2 .3l-1.32-.22a.33.33 0 0 0-.37.32v5.64a.32.32 0 0 0 .32.32h1a.32.32 0 0 0 .32-.32v-3c0-1 .29-1.41 2.08-1.47a.33.33 0 0 0 .31-.32v-.89a.32.32 0 0 0-.33-.32m-12.33.16h-1.13v-1.2a.32.32 0 0 0-.33-.32h-1a.32.32 0 0 0-.32.32v1.2h-.53a.32.32 0 0 0-.32.33v.82a.32.32 0 0 0 .32.32h.54v2.79A1.84 1.84 0 0 0 29 20.69a5.15 5.15 0 0 0 1-.07.32.32 0 0 0 .26-.31v-.9a.26.26 0 0 0-.32-.26 2.17 2.17 0 0 1-.43 0c-.57 0-.69-.33-.69-.82v-2.52h1.13a.32.32 0 0 0 .32-.32v-.82a.33.33 0 0 0-.33-.32M25.68 19l-.82-.49a.34.34 0 0 0-.38 0 1.68 1.68 0 0 1-1.31.61 1.71 1.71 0 1 1 1.25-2.87.31.31 0 0 0 .4.05l.81-.47a.33.33 0 0 0 .09-.49 3.34 3.34 0 0 0-2.56-1.18 3.25 3.25 0 1 0 0 6.5 3.3 3.3 0 0 0 2.59-1.24.32.32 0 0 0-.09-.47m-8.07-2.21a1.47 1.47 0 0 0-1.45-1.17 1.72 1.72 0 0 0-1.56 1.18h2.95Zm1.69.68v.21A.33.33 0 0 1 19 18h-4.46a1.67 1.67 0 0 0 1.72 1.29 2 2 0 0 0 1.35-.49.32.32 0 0 1 .42 0l.6.48a.32.32 0 0 1 .05.47 3.3 3.3 0 0 1-2.4 1A3.21 3.21 0 0 1 13 17.54a3.17 3.17 0 1 1 6.33-.05",
      style: {
        fill: "#fff",
      },
    })
  );

Nectar.defaultProps = {
  viewBox: "0 0 48 40",
  role: "img",
};

const Argos = (props) =>
  /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement(
      "defs",
      null,
      /*#__PURE__*/ React.createElement("style", null, ".cls-5{fill:#fff}")
    ),
    /*#__PURE__*/ React.createElement("path", {
      style: {
        fill: "#1d1d1b",
      },
      d: "M.04.51h47.91v40.98H.04z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      style: {
        fill: "#008035",
      },
      d: "m17.31.51 30.65 30.23v-8.4L25.82.51h-8.51z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      style: {
        fill: "#f59f00",
      },
      d: "m25.75.51 22.21 21.9-.01-8.4L34.26.51h-8.51z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      style: {
        fill: "#e20613",
      },
      d: "m34.19.51 13.76 13.57v-8.4L42.7.51h-8.51z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      className: "cls-5",
      d:
        "M23.66 31.16a35 35 0 0 0 19.11-5.63c.49-.32.21-.82-.32-.6-7.34 3-12.1 4.14-18.8 4.14S12.21 28 4.86 24.94c-.53-.22-.81.29-.32.6a35 35 0 0 0 19.12 5.62M37.14 17.35c0 1.27 1.57 1.62 2.36 1.83.4.1 1.19.3 1.22.8s-.61.84-1.24.84a1.7 1.7 0 0 1-1.48-.74.51.51 0 0 0-.62-.18 3.59 3.59 0 0 0-.94.47.45.45 0 0 0-.14.57 3.09 3.09 0 0 0 3 1.59c1.83 0 3.43-.81 3.82-2.44s-.9-2.18-2.09-2.53c-.77-.22-1.34-.41-1.3-.93s1.28-.9 2.14.1a.55.55 0 0 0 .68.19 6.85 6.85 0 0 0 .84-.39c.3-.18.35-.36.18-.66a3.06 3.06 0 0 0-2.71-1.3c-2.28 0-3.77 1.19-3.77 2.78M11.73 14c0 1.28.16 4.24.16 4.24h-3A42 42 0 0 1 11.62 14c.09-.12.11 0 .11 0m.15-2.43a1.58 1.58 0 0 0-1.29.52 83.74 83.74 0 0 0-6.24 9.74c-.16.28 0 .54.29.54h1.63A.62.62 0 0 0 6.9 22c.2-.33.68-1.18 1.09-1.89h3.9s0 1.33.06 1.82c0 .27.17.44.52.44h1.44a.39.39 0 0 0 .44-.45c0-1.39-.4-8.22-.52-9.81 0-.39-.21-.56-.67-.56h-1.28M31.8 20.87c1.36 0 1.95-1.13 2.29-2.32s.47-2.32-.9-2.32-1.95 1.12-2.3 2.32-.47 2.32.91 2.32m-.15 1.66c-2.45 0-3.58-1.62-3.08-4a4.78 4.78 0 0 1 4.77-4c2.45 0 3.57 1.62 3.07 4a4.77 4.77 0 0 1-4.76 4",
    }),
    /*#__PURE__*/ React.createElement("path", {
      className: "cls-5",
      d:
        "M27.13 21.52c.59-2.33 1.14-4.54 1.5-6.11a.47.47 0 0 0-.44-.63h-1a.62.62 0 0 0-.62.47c0 .06 0 .14-.08.31h-.07a2.2 2.2 0 0 0-1.88-.91c-2 0-3.38 1.93-3.94 3.71a4 4 0 0 0 .07 3.11 2.38 2.38 0 0 0 2.13 1.05 2.56 2.56 0 0 0 2-.75h.06c-.5 1.74-1.57 2.22-2.4 2.22a2.19 2.19 0 0 1-1.14-.34.7.7 0 0 0-.69-.13 3.15 3.15 0 0 0-1 .43.44.44 0 0 0-.16.68A3.72 3.72 0 0 0 22.59 26c2.23 0 3.78-1.52 4.54-4.48m-4.6-2.91c.44-1.53 1.17-2.32 2.19-2.29 1.29 0 1 1.31.75 2.28-.44 1.48-1.11 2.25-2.18 2.17s-1-1.34-.76-2.16M21.77 15.13c.13-.13.06-.34-.18-.34-1.26 0-2.47 0-3.37.82 0-.06.05-.22.1-.4a.3.3 0 0 0-.31-.39h-1.28a.44.44 0 0 0-.5.42c-.13.63-1.11 5.41-1.39 6.84a.3.3 0 0 0 .3.35h1.49a.39.39 0 0 0 .45-.35l.65-3.2a2.91 2.91 0 0 1 .78-1.64 2.6 2.6 0 0 1 1.49-.45.73.73 0 0 0 .69-.41 7.73 7.73 0 0 1 1.05-1.25",
    })
  );

Argos.defaultProps = {
  viewBox: "0 0 48 42",
  role: "img",
};

export { Sainsburys, Nectar, Argos };
// Argos,
// SainsburysSmartShop,
// NectarWordmarkWhite,
